/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// et
t.add("cart.tickets.no_available_tickets_for_seating", "\u00dchtegi valitud istekohaga piletit ei ole saadaval", "PayseraCartBundle", "et");
t.add("cart.tickets.no_available_tickets", "\u00dchtegi piletit ei ole saadaval", "PayseraCartBundle", "et");
t.add("paysera_cart.discount.invalid_code", "Kehtetu sooduskood", "PayseraCartBundle", "et");
})(Translator);
